// This page is not implemented on web, only native
const NoOp = () => {
  return <></>
}

export default NoOp
